<div class="banner-background relative z-0">
  <div class="banner-container lg:mx-auto lg:screen-max-size">
    <h1 class="banner-title">{{ title }}</h1>
  </div>
  <rd-banner-image
    [bannerSrc]="{
      desktop: 'offer-banner-desktop',
      mobile: 'offer-banner-mobile'
    }"></rd-banner-image>
</div>
